export var InvestAccountName;
(function (InvestAccountName) {
    InvestAccountName["INVA"] = "INVA";
    InvestAccountName["INVS"] = "INVS";
    InvestAccountName["INVW"] = "INVW";
})(InvestAccountName || (InvestAccountName = {}));
export var DepositAccountName;
(function (DepositAccountName) {
    DepositAccountName["CHECKING"] = "CHECKING";
    DepositAccountName["SAVINGS"] = "SAVINGS";
    DepositAccountName["CD"] = "CD";
    DepositAccountName["IRA"] = "IRA";
})(DepositAccountName || (DepositAccountName = {}));
export var MortgageAccountName;
(function (MortgageAccountName) {
    MortgageAccountName["MORTGAGE"] = "MORTGAGE";
    MortgageAccountName["HOME_EQUITY"] = "HOME_EQUITY";
})(MortgageAccountName || (MortgageAccountName = {}));
export var CCAccountName;
(function (CCAccountName) {
    CCAccountName["PLATINUM"] = "PLATINUM";
    CCAccountName["EVERYDAY"] = "EVERYDAY";
    CCAccountName["UNLIMITED"] = "UNLIMITED";
})(CCAccountName || (CCAccountName = {}));
export var AutoAccountName;
(function (AutoAccountName) {
    AutoAccountName["AUTO"] = "AUTO";
})(AutoAccountName || (AutoAccountName = {}));
//# sourceMappingURL=data.js.map